import { createFileRoute } from "@tanstack/react-router";
import AdminAnnouncementEdit from "@/pages/AdminAnnouncementEdit";

export const Route = createFileRoute("/_owner/owner/announcements/new")({
  component: AdminAnnouncementEdit,
});
